var Quantity = /** @class */ (function () {
    function Quantity(data) {
        this.input = data.container.querySelector(data.selectors.input || 'input');
        this.decreaseButton = data.container.querySelector(data.selectors.decrease);
        this.increaseButton = data.container.querySelector(data.selectors.increase);
    }
    Quantity.prototype.setEventListener = function () {
        var _this = this;
        var _a, _b, _c;
        (_a = this.decreaseButton) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () { return _this.decrease(); });
        (_b = this.increaseButton) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () { return _this.increase(); });
        (_c = this.input) === null || _c === void 0 ? void 0 : _c.addEventListener('change', function () { return _this.onChange(_this.input.value); });
    };
    Quantity.prototype.increase = function () {
        var currentValue = this.getValue();
        this.onChange(currentValue + 1);
    };
    Quantity.prototype.decrease = function () {
        var currentValue = this.getValue();
        this.onChange(Math.max(currentValue - 1, 0));
    };
    Quantity.prototype.getValue = function () {
        return parseInt(this.input.value, 10);
    };
    Quantity.prototype.onChange = function (value) {
        this.input.value = value.toString();
    };
    return Quantity;
}());
export { Quantity };
